import React from 'react'

import { useModal } from '../../hooks/modal'
import { useDeleteRequest } from '../../hooks/request'
import { PRICE_DETAIL } from '../../urls'
import PriceUpdate from './PriceUpdate'
import Button from '../../components/common/Button'

export default function PriceItem({ item, index, expenseReport }) {
    const productRemove = useDeleteRequest({ url: PRICE_DETAIL.replace('{id}', item.id) })

    async function onDelete() {
        if (global.confirm('Вы действительно хотите удалить?')) {
            await productRemove.request()
            expenseReport.request()
        }
    }

    const [showUpdateModal, hideUpdateModal] = useModal(
        <PriceUpdate
            clients={item}
            item={item}
            onCancel={() => {
                expenseReport.request()
                hideUpdateModal()
            }}
        />,
    )

    function format(value) {
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            useGrouping: true,
        })
            .format(value)
            .replace(/,/g, ' ')
    }

    return (
        <tr className=" is-size-6" key={item.id}>
            <td className="is-size-6">{index + 1}</td>
            <td className="is-size-6">{format(item.electricityPrice)}</td>
            <td className="is-size-6">{format(item.waterPrice)}</td>
            <td className="is-size-6">{format(item.gasPrice)}</td>
            <td>
                <div style={{ display: 'flex' }} className="has-text-right">
                    <Button onClick={showUpdateModal} className="mr-2 button is-success is-outlined is-small" icon="pencil-outline" />
                    <Button onClick={onDelete} className="button is-danger mr-2 is-outlined is-small" icon="trash" />
                </div>
            </td>
        </tr>
    )
}
